import { render, staticRenderFns } from "./tabBarWrapper.vue?vue&type=template&id=1e59f61b&"
import script from "./tabBarWrapper.vue?vue&type=script&lang=js&"
export * from "./tabBarWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports